import {gql} from "@apollo/client";
import {ApolloClientQuery} from "./_setup";

const GET_AVAILABLE_PRODUCT_BY_USERID = gql`
    query getAvailableProductByUserId($input: ProductSearchInputByUserId) {
        getAvailableProductByUserId(input: $input) {
            ... on ProductArray {
                data {
                    _id
                    name
                    leverage
                }
            }
            ... on BaseError {
                errMsg
                errKey
            }
        }
    }
`;

export async function getAvailableProductUserId(userId, serverName) {
    const variables = {
        input: {
            userId: userId,
            serverName: serverName,
        },
        context: {
            headers: {
                authorization: "Bearer " + localStorage.getItem("a_t"),
            },
        },
    };
    const execute = await ApolloClientQuery(GET_AVAILABLE_PRODUCT_BY_USERID, variables, false);

    return execute;
}

const GET_ALL_AVAILABLE_PRODUCT_BY_USERID = gql`
    query getAllAvailableProductByUserId($userid: String!, $productType: [String]) {
        getAllAvailableProductByUserId(userid: $userid, productType: $productType) {
            ... on ProductArray {
                data {
                    _id
                    name
                    leverage
                    minDeposit
                    server {
                        _id
                        name
                        brokerName
                        platform
                        plantId
                    }
                    spreadGroup {
                        _id
                        name
                        groupId
                    }
                    spreadGroupMt5 { group }
                    productType
                }
            }
            ... on BaseError {
                errMsg
                errKey
            }
        }
    }
`;

export async function getAllAvailableProductByUserId(userid, productType) {
    const variables = {
        userid: userid,
        productType: productType,
        context: {
            headers: {
                authorization: "Bearer " + localStorage.getItem("a_t"),
            },
        },
    };
    const execute = await ApolloClientQuery(GET_ALL_AVAILABLE_PRODUCT_BY_USERID, variables, false);

    return execute;
}

const GET_PRODUCT_BY_ID = gql`
    query getProductByID($id: String!) {
        getProductByID(id: $id) {
            ... on Product {
                leverage
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

export async function getProductById(id) {
    const variables = {
        id: id,
        context: {
            headers: {
                authorization: "Bearer " + localStorage.getItem("a_t"),
            },
        },
    };
    const execute = await ApolloClientQuery(GET_PRODUCT_BY_ID, variables, false);

    return execute;
}
